module.exports = __webpack_public_path__ + "static/img/leftbj.966c0ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/leftbj.png
// module id = 9Xl4
// module chunks = 0